var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center space-x-2 border border-gray-300 rounded-full h-[35px] px-3 py-2"},[_c('span',{staticClass:"text-gray-700 font-medium"},[_vm._v("Sematan Agenda :")]),_c('span',{staticClass:"font-bold text-gray-800"},[_vm._v(_vm._s(_vm.pinned)+"/"+_vm._s(_vm.maxPinned))])])
}
var staticRenderFns = []

export { render, staticRenderFns }